import { customLanguageDetector, defaultLanguage } from '@/i18n/util.ts';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultNS, resources } from './locales';

i18n
  // 使用自定义语言检测器
  .use(customLanguageDetector)
  // 绑定 react-i18next
  .use(initReactI18next)
  // 初始化
  .init({
    // 全局启用
    postProcess: ['tms-marker'],
    // 多语言资源
    resources,
    // 默认命名空间
    defaultNS,
    // 默认语言（当检测失败时使用）
    fallbackLng: defaultLanguage,
    // 指定语言，以后开启国际化时，删掉
    lng: defaultLanguage,
    debug: false,
    interpolation: {
      // React 已经处理 XSS，不需要转义
      escapeValue: false,
    },
    detection: {
      // 配置语言检测策略：优先使用自定义检测器
      order: ['normalizeLanguageDetector', 'localStorage', 'navigator'],
      // 用户手动切换语言后会被存储
      caches: ['localStorage'],
    },
  })
  .then();
